/* tslint:disable:component-selector */
import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'pie-legend',
  templateUrl: './pie-legend.component.html',
  styleUrls: ['./pie-legend.component.css']
})
export class PieLegendComponent implements OnInit {

  option;

  @Input() title: string;

  @Input() europeData: number;
  @Input() northAmericaData: number;
  @Input() southAmericaData: number;
  @Input() asiaData: number;
  @Input() oceaniaData: number;
  @Input() africaData: number;

  constructor() {
  }

  ngOnInit(): void {
    this.option = {
      title: {
        text: this.title,
        subtext: 'Distribution by continent',
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        formatter: '{d}%'
      },
      legend: {
        // orient: 'vertical',
        // top: 'middle',
        bottom: 10,
        left: 'center',
        data: ['Asia', 'N. America', 'S. America', 'Europe', 'Africa', 'Oceania']
      },
      series: [
        {
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [{value: this.roundData(this.asiaData), name: 'Asia'},
            {value: this.roundData(this.northAmericaData), name: 'N. America'},
            {value: this.roundData(this.southAmericaData), name: 'S. America'},
            {value: this.roundData(this.europeData), name: 'Europe'},
            {value: this.roundData(this.africaData), name: 'Africa'},
            {value: this.roundData(this.oceaniaData), name: 'Oceania'}
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  }

  roundData(inputNumber: number): number {
    return inputNumber * 100;
  }


}
